import router from './router'
import mortgageMessages from './localization'

export default {
  router,
  localization: mortgageMessages,
}
